<script lang="ts" setup>
import BaseValue from '@/components/BaseValue.vue';
import useJupData from './useJupData';
import BaseAmount from '@/components/BaseAmount.vue';

const { total, stakedPourcent, isFullStaked } = useJupData();

function stake() {
  open('https://vote.jup.ag', '_blank');
}

function buy() {
  open('https://jup.ag/swap/SOL-JUP', '_blank');
}
</script>

<template>
  <div class="flex flex-col gap-1">
    <div class="flex flex-row gap-2 items-center">
      <img src="/src/assets/logo-dark.svg" alt="Jupiter logo" width="18px" />
      <p>JUP Holdings</p>
    </div>
    <div class="flex flex-col gap-1">
      <div class="flex flex-row gap-2 items-center">
        <p class="text-4xl font-extrabold whitespace-nowrap">
          <BaseAmount :amount="total" /> JUP
        </p>
        <v-btn v-if="total === 0" variant="tonal" @click="buy" color="primary">
          Buy
        </v-btn>
      </div>
      <div class="flex flex-row gap-2 items-center">
        <p class="text-disabled">
          {{ Number(stakedPourcent).toFixed(2) }}% staked
        </p>
        <v-btn
          variant="tonal"
          @click="stake"
          color="primary"
          size="small"
          v-if="!isFullStaked && total > 0"
        >
          Stake
        </v-btn>
      </div>
    </div>
  </div>
</template>
